module.exports = __webpack_public_path__ + "img/icon_win.252588c3.png";